import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoresMainComponent } from './stores-main.component';
import { PageLayoutModule } from 'src/@vex/components/page-layout/page-layout.module';
import { SecondaryToolbarModule } from 'src/@vex/components/secondary-toolbar/secondary-toolbar.module';
import { MatButtonModule } from '@angular/material/button';
import { FlexLayoutModule } from '@angular/flex-layout';
import { BreadcrumbsModule } from 'src/@vex/components/breadcrumbs/breadcrumbs.module';
import { IconModule } from '@visurel/iconify-angular';
import { MatIconModule } from '@angular/material/icon';
import { ContainerModule } from 'src/@vex/directives/container/container.module';
import { Honeycomb } from 'src/app/services/honeycomb-api/honeycomb-api';
import { WidgetTableModule } from 'src/@vex/components/widgets/widget-table/widget-table.module';
import { ApiCaller } from 'src/app/services/honeycomb-api/api-caller';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ColorFadeModule } from 'src/@vex/pipes/color/color-fade.module';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'src/app/shared.module';
import { StarRatingModule } from 'src/@vex/components/star-rating/star-rating.module';
import { ButtonRatingModule } from 'src/@vex/components/button-rating/button-rating.module';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSortModule } from '@angular/material/sort';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MyStoresListComponent } from '../my-stores-list/my-stores-list.component';

@NgModule({
  declarations: [
    StoresMainComponent,
    MyStoresListComponent
  ],
  providers: [
    Honeycomb.Tenant.Tasker.IService.Controller.TaskController,
    {
      provide: 'ReportController',
      useFactory: (apiCaller: ApiCaller) => (new Honeycomb.Tenant.Reports.IService.ReportController(apiCaller)),
      deps: [ApiCaller]
    }
  ],
  imports: [
    CommonModule,

    PageLayoutModule,
    SecondaryToolbarModule,
    SharedModule,

    MatButtonModule,
    FlexLayoutModule,
    BreadcrumbsModule,
    IconModule,
    MatIconModule,
    ContainerModule,
    StarRatingModule,
    ButtonRatingModule,

    WidgetTableModule,

    PageLayoutModule,
    FlexLayoutModule,
    BreadcrumbsModule,
    MatPaginatorModule,
    MatTableModule,
    MatAutocompleteModule,
    MatSortModule,
    MatCheckboxModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    IconModule,
    FormsModule,
    MatTooltipModule,
    ReactiveFormsModule,
    ContainerModule,
    MatSelectModule,
    ColorFadeModule,
    MatButtonToggleModule,

    TranslateModule
  ],
  entryComponents: [
    StoresMainComponent,
    MyStoresListComponent
  ]
})
export class StoresMainModule { }
